<template>
  <div>    
    <scroller
      :on-infinite="infinite"
      ref="my_scroller"
    >  
      <div style="height: 1px; color: white; text-align: center;">-</div>  
      <div v-for="item in list" :key="item.id" class="datum" @click="() => clickItem(item)">
        <img :src="sourceIcon(item)" alt="" class="datum__img">
        <div class="datum__right">
          <div class="datum__title">{{item.title}}</div>
          <div class="datum__info">
            <div class="datum__info__left">上传者：{{item.user ? item.user.profile.nickname : '柳芽天使'}}</div>
            <div>{{item.views}}次下载</div>

            <div v-if="item.price > 0" class="datum__price">付费文档</div>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
import { get, post } from '../../utils/request'
import LY from '../../utils/liuya-js-sdk'

export default {
  name: 'Mock',
  data() {
    return {
      list: [],
      page: 1,
      refresh: false,

      title: '模考试卷电子版',
      datumId: 39,
    }
  },
  mounted() {
    document.title = this.$route.query.isGraduate ? '医考复试资料' : this.title    
  },
  methods: {
    sourceIcon(item) {
      let source;
      if (/powerpoint|ppt/.test(item.ext) || /ppt/.test(item.title)) {
        source = 'https://file.liuyamed.com/FuPW7h2NISBScKrYeL2AeXJ3bu_H'
      } else if (/excel|xls|csv|sheet/.test(item.ext) || /excel|xls|csv|sheet/.test(item.title)) {
        source = 'https://file.liuyamed.com/FoWH8Y-GJ6xswQ7-DW2E82JR9S9O'
      } else if (/word|doc/.test(item.ext) || /word|doc/.test(item.title)) {
        source = 'https://file.liuyamed.com/FvIyzm2s_MuxF1u3RhIRrBRPDVbg'
      } else {
        source = 'https://file.liuyamed.com/FiPj19UaClXEyZAfCbWvDlYAuAT1'
      }
      return source;
    },
    clickItem(item) {
      if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 4,
            value: `/pages/clinic/medicalDetails?id=${item.id}`
          }))
        }
    },    
    infinite(done) {      
      console.log('worksss')
      this.getData(this.page, done)
    },
    getData(page, done) {
      this.page += 1
      get('https://liuya.baichuanbailian.com/api/1.0/datum/index', {
        // cate_id: this.datumId,
        'cate_id_list': this.$route.query.isGraduate ? '8,' : '1,', // '33,36,38,39,40,41',
        page
      }).then(res => {
        if (res.data.data.length != 0) {
          this.list = this.list.concat(res.data.data)
          done && done()
        } else {
          if (done) {
            done(true)
          } else {
            this.$refs.my_scroller.finishInfinite(true);
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.datum {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  border-bottom: 1px solid #EFEFEF;

  &__img {
    width: 39px !important;
    height: 45px;
    margin-right: 19.5px;
  }

  &__right {
    flex: 1;
    height: 45px;   
    display: flex;
    flex-direction: column;    
    justify-content: space-around;
    overflow: hidden;
  }

  // &__datum {
  //   font-size: 14px;
  // }

  &__title {
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__info {
    position: relative;
    display: flex;    
    font-size: 10px;
    color: #AEAEAE;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    &__left {
      margin-right: 12.5px;
    }
  }

  &__price {
    position: absolute;
    top: 0;
    right: 0;
    padding: 1px 8.5px;
    border-radius: 12px;
    font-size: 10px;
    background: #FEE412;
    color: #000;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/datum/mock.vue